import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17 3.5H7C5.9 3.5 5.01 4.4 5.01 5.5L5 21.5L12 18.5L19 21.5V5.5C19 4.4 18.1 3.5 17 3.5Z",
		fill: "currentColor"
	})
});
export default SvgBookmark;
